import React, {useEffect} from "react";
import Footer from "../user/components/footer";
import Header from "../user/components/header";

const FAQBuyer = () => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    }, []);

    
    return (
        <>
            <Header />
            <div className="sec_latestpd" style={{ marginTop: "150px" }}>
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-md-12">
                            <h2 className="sec_title">FAQ's FOR BUYER(S)</h2>
                            <hr />
                        </div>
                        <div className="col-md-12">
                            <h6><b>How do I signup/register myself?</b></h6>
                            <p>You can click on the top right corner of the portal, <b>www.IndiGalleria.com</b>. After that click on "<b>Create Account</b>" to register.</p>

                            <br />
                            <h6><b>How do I place an order on IndiGalleria.Com?</b></h6>
                            <p>Placing an order on <b>IndiGalleria.com</b> is a simple three-step process. <b>Step 1</b>: Click on the "<b>Add to Cart</b>" icon next to any work you like. The artwork will then be added to the cart. <b>Step 2</b>: Click on "<b>Checkout</b>" when you are ready to make the payment. Fill in the details like Address, Phone number, etc. <b>Step 3</b>: Click on "<b>Pay Now</b>" to make the payment where you select the payment method and make the payment.</p>

                            <br />
                            <h6><b>What is an Authenticity Certificate?</b></h6>
                            <p>An ‘Authenticity Certificate’ is a certificate of authority by the artist. It proves that the artwork is an original and unique work of art by the artist. We at <b>IndiGalleria</b> ensure that all artworks sold are authentic and original.</p>

                            <br />
                            <h6><b>I need help choosing the right artwork, can you help?</b></h6>
                            <p>Of course, we at <b>IndiGalleria</b> make sure that you get the best services whenever you want. We have a dedicated art advisory team that is available via email to help you. We are just a click away. You may write to us at <b>info@IndiGalleria.com</b>.</p>
                            <br />
                            <h6><b>How long will it take to receive my order?</b></h6>
                            <p>Our endeavor is to ensure that you get your work asap once you have bought it. Generally, it depends upon your location, but the maximum time that we take is <b>10 - 15 working days</b> (excluding local statutory holidays). We also keep you notified via email &/or SMS at every processing stage. In case you have any questions on this, you may write to <b>info@IndiGalleria.com</b>.</p>
                            <br />
                            <h6><b>I have received my artwork but it's damaged what should I do now?</b></h6>
                            <p>We at <b>IndiGalleria</b> make sure that every artwork goes through strict quality testing before getting shipped out to customers. We will send a short close-up video of your artwork while packing to show as proof that the artwork is in pristine condition without any damage. However, if you still receive damaged artwork please write to <b>info@IndiGalleria.com</b> for our immediate response and action.</p>

                            <h6><b>Will I get my artwork framed?</b></h6>
                            <p>Everybody has their own taste when it comes to framing an artwork, which is why we at <b>IndiGalleria</b> send artwork in a rolled form. There may be a few artworks that are shipped as framed. However, if you still need any support in terms of framing options, you may write to us at <b>info@IndiGalleria.com</b></p>
                            <br />
                            <h6><b>Who do I contact if I have any questions?</b></h6>
                            <p>All the options have been provided on the <b>Contact Us</b> page on our website.</p>
                            <br />
                            <h6><b>Is it safe to make the payment online?</b></h6>
                            <p>Your safety and security are of prime concern to us. That is why we don't encourage our customers to share their bank or credit card details either on the <b>IndiGalleria</b> website or with any of our team members. We have <b>PayPal</b> as our payment gateway partner. They use state-of-the-art technology to enable payments /online transactions and have highly secure servers.</p>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default FAQBuyer;